import Services from '../services'
export default {
  name: 'modifiers',
  mixins: [Services],
  data: () => ({
    modifier_edit_index: -1,
    modifier: {
      services: [],
      options: [{option_name: null, price: null}]
    },
    modifers: [],
    modifers_page: 1,
    modifers_total: 0,
    numPages: 1,
    data_loading: false
  }),
  methods: {
    async remove_modifiers(items) {
      var indices = []
      for (const index in items) {
        indices.push(items[index]._id)
      }
      await this.$communicator('delete_modifiers', {
        params: {
          indexes: indices
        }
      })
      this.$toast.success("Success", {timeout: 2000});
      this.update_modifiers()
    },
    async update_modifiers() {
      this.data_loading = true
      const modifiers = this.$communicator.then(this, await this.$communicator('modifiers', {
        arguments: [10, this.modifers_page],
        params: {
          service: this.store?._id
        }
      }))
      if (modifiers) {
        this.modifers_total = modifiers.page
        this.modifers = this.$copy(modifiers.data)
        this.numPages = modifiers.page
      }
      this.data_loading = false
    },
    async typing_modifier(item) {
      if (item == null) {
        this.modifier_edit_index = -1
        this.modifier = {
          services: [],
          options: [{option_name: null, price: null}]
        }
        for (const index in this.services) {
          this.modifier.services.push({
            service: this.services[index]._id,
            available: true,
            service_name: this.services[index].name
          })
        }
      }
      else {

        this.modifier_edit_index = item['_id']
        const modifier = this.$communicator.then(this,
          await this.$communicator('modifier_get_by_id', {
            arguments: [this.modifier_edit_index]
          }))
        if (modifier) {
          this.modifier = modifier
        }
        // this.modifier = this.$copy(item)
        delete this.modifier['_id']
      }
    },
    async save_modifier() {
      if (this.modifier_edit_index == -1) {
        await this.$communicator('create_modifier', {
          params: this.modifier
        })
        this.$toast.success("Success", {timeout: 2000})
      }
      else {
        await this.$communicator('update_modifier', {
          arguments: [this.modifier_edit_index],
          params: this.modifier
        })
        this.$toast.success("Success", {timeout: 2000});
      }
      this.update_modifiers()
    },
    modifiers_add_option() {
      this.modifier.options.push({option_name: null, price: null})
    },
    modifiers_remove_option(index) {
      var options = []
      for (const i in this.modifier.options) {
        if (i != index) {
          options.push(this.modifier.options[i])
        }
      }
      this.modifier.options = options
    }
  },
  mounted() {
    this.update_modifiers()
  },
  watch: {
    services: {
      deep: true, handler() {
        this.modifier.services = []
        for (const index in this.services) {
          this.modifier.services.push({
            service: this.services[index]._id,
            available: false,
            service_name: this.services[index].name
          })
        }
      }
    },
    store: {
      deep: true, handler() {
        this.update_modifiers()
      }
    }
  }
}
